import {Link} from 'react-router-dom'
import AppContext from '../../context/AppContext'

import {
  VideoCardContainer,
  VideoCardThumnailImg,
  VideoCardDetails,
  VideoCardTitle,
  VideoCardChannelName,
  VideoCardViewAndDuration,
  VideoCardViews,
  ImgContainer,
  VideoCardDuration,
  LinkEl,
} from './styledComponents'

const VideoCard = props => {
  const {videoItem} = props
  return (
    <AppContext.Consumer>
      {value => {
        const {theme, duration} = value
        return (
          <LinkEl as={Link} to={`/videos/${videoItem.id}`}>
            <VideoCardContainer theme={theme}>
              <ImgContainer>
                <VideoCardThumnailImg
                  src={videoItem.thumbnailUrl}
                  alt="video thumbnail"
                />
              </ImgContainer>
              <VideoCardDetails theme={theme}>
                <VideoCardTitle theme={theme}>{videoItem.title}</VideoCardTitle>
                <VideoCardChannelName theme={theme}>
                  {videoItem.channel.name}
                </VideoCardChannelName>
                <VideoCardViewAndDuration theme={theme}>
                  <VideoCardViews theme={theme}>
                    {videoItem.viewCount} views
                  </VideoCardViews>
                  <VideoCardDuration theme={theme}>
                    {videoItem.publishedAt} {duration(videoItem.publishedAt)}
                  </VideoCardDuration>
                </VideoCardViewAndDuration>
              </VideoCardDetails>
            </VideoCardContainer>
          </LinkEl>
        )
      }}
    </AppContext.Consumer>
  )
}

export default VideoCard
